// ── useBgMediaSession — уведомление «что играет» для фонового аудио ──────────
// Фоновое аудио (нижняя панель, пока открыт другой проект) играет своим <audio>.
// Заиграло — уведомление и экран блокировки показывают его: название, время и
// полоску, кнопки управляют им (⏮ ⏭ — на 10 с назад и вперёд: карточек у фонового
// звука на этом экране нет). Остановили — уведомление возвращается к плееру.

import { useEffect } from 'react';
import { appIconDataUri, mediaSession } from '../mediaSession';

const STEP = 10;

export default function useBgMediaSession(audioRef, project) {
  const id = project?.id;
  const name = project?.name;
  useEffect(() => {
    const a = audioRef.current;
    if (!a || !id) return undefined;
    const ms = mediaSession('bg');
    const pos = () => ({ duration: a.duration, position: a.currentTime, playbackRate: a.playbackRate });
    let alive = true;
    appIconDataUri().then((icon) => {
      if (alive) ms.setMetadata({ title: name || 'AntonCards', artist: 'AntonCards', album: name || '', capArtworkDataUri: icon });
    });
    ms.setActionHandler('play', () => { a.play().catch(() => {}); });
    ms.setActionHandler('pause', () => a.pause());
    ms.setActionHandler('previoustrack', () => { a.currentTime = Math.max(0, a.currentTime - STEP); });
    ms.setActionHandler('nexttrack', () => { a.currentTime = Math.min(a.duration || 0, a.currentTime + STEP); });
    ms.setActionHandler('seekto', (d) => { if (d?.seekTime != null) a.currentTime = d.seekTime; });

    const onPlay = () => { ms.claim(); ms.setPlaybackState('playing'); ms.setPositionState(pos()); };
    const onPause = () => { ms.setPlaybackState('paused'); ms.setPositionState(pos()); };
    const onMove = () => ms.setPositionState(pos());
    a.addEventListener('play', onPlay);
    a.addEventListener('pause', onPause);
    a.addEventListener('seeked', onMove);
    a.addEventListener('ratechange', onMove);
    a.addEventListener('timeupdate', onMove);
    if (!a.paused) onPlay();
    return () => {
      alive = false;
      a.removeEventListener('play', onPlay);
      a.removeEventListener('pause', onPause);
      a.removeEventListener('seeked', onMove);
      a.removeEventListener('ratechange', onMove);
      a.removeEventListener('timeupdate', onMove);
      ms.setPlaybackState('paused');
      ms.release();
    };
  }, [audioRef, id, name]);
}
